module.exports = __webpack_public_path__ + "static/media/delete-black.56397e00.svg";